<template>
    <div class="bottom">
        <section class="sponsors-section" style="background-color:#6aaf08!important;">
            <div class="container">
                <ul class="slider owl-theme">
                    <li v-for="link in linkList">
                        <a :href="link.links_url" target="_blank">
                            <img :src="link.links_img" :alt="link.links_name" >
                        </a>
                    </li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "page-footer-link",
        props: ['linkList'],
        mounted(){
            this.initSiteMap();
        },
        methods:{
            initSiteMap(){
				$('.sponsors-section .slider').owlCarousel({
		            loop: true,
		            margin: 20,
		            nav: true,
		            autoplay: 5000,
		            responsive: {
		                0: {
		                    items: 1
		                },
		                600: {
		                    items: 2
		                },
		                800: {
		                    items: 3
		                },
		                1024: {
		                    items: 4
		                },
		                1100: {
		                    items: 5
		                }
		            }
		        });
			}
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/PageFooterLink.vue